import { MessageCircle } from "lucide-react";

type Props = {
    label: string;
    onClick?: () => void;
    unreadCount?: number;
}

const ChatButton = ({ label, onClick, unreadCount = 0 }: Props) => {
    return (
        <button
            onClick={onClick || (() => {
                console.log('Abrir chat com terapeuta');
            })}
            className="px-2 py-1 text-xs sm:text-sm bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium transition-all flex items-center justify-center gap-2 shadow-md hover:shadow-lg relative"
            title="Conversar com o terapeuta"
        >
            <MessageCircle className="w-4 h-4" />
            {label}
            {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-lg">
                    {unreadCount > 9 ? '9+' : unreadCount}
                </span>
            )}
        </button>
    );
}

export default ChatButton;